<template>
  <div id="page-user-view">
    <div id="user-data">
      <vx-card title="Yeni" class="mb-base">
        <ValidationObserver tag="form" ref="editForm" v-on:submit.prevent>
          <div class="vx-row">
            <div class="vx-col w-1/3 mb-5">
              <ValidationProvider name="Rôl Grubu Adı" rules="required" v-slot="{ errors }">
                <vs-input
                  label="Rôl Grubu Adı"
                  v-model="formData.RoleGroupName"
                  class="w-full"
                  name="item-name"
                />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-1/3">
              <div
                class="search-full-container search-person sm:mr-4 mr-0 sm:w-auto sm:order-normal order-3 sm:mt-0 mt-3"
                :class="{'flex': showFullSearch}"
                v-show="showFullSearch"
              >
                <vx-auto-suggest
                  ref="navbarSearch"
                  :autoFocus="showFullSearch"
                  :data="navbarSearchAndPinList"
                  search_key="title"
                  class="w-full"
                  inputClassses="w-full vs-input-no-border vs-input-no-shdow-focus"
                  icon="SearchIcon"
                  placeholder="Personel adı..."
                  @selected="selected"
                  @closeSearchbar="showFullSearch = false"
                >
                  <template v-slot:group="{ group_name }">
                    <p class="font-semibold text-primary">Personel</p>
                  </template>

                  <!-- Contacts Suggestion -->
                  <template v-slot:users="{ suggestion }">
                    <div class="flex items-center justify-between">
                      <div class="flex items-center">
                        <img
                          :src="suggestion.Picture"
                          :alt="suggestion.Name"
                          class="w-8 h-8 mr-3 rounded-full"
                        />
                        <div class="leading-none mt-1">
                          <p>{{ suggestion.Name }}</p>
                        </div>
                      </div>
                    </div>
                  </template>

                  <!-- No Items Slot -->
                  <template v-slot:noResult="{ group_name }">
                    <div class="flex items-center">
                      <feather-icon icon="InfoIcon" svgClasses="h-5 w-5" class="mr-4" />
                      <span>Personel bulunamadı.</span>
                    </div>
                  </template>
                </vx-auto-suggest>

                <div class="relative search-person-close right-0 h-full z-50">
                  <feather-icon
                    icon="XIcon"
                    class="px-4 cursor-pointer h-full close-search-icon"
                    @click="showFullSearch = false"
                  />
                </div>
              </div>
              <vs-button
                v-show="!showFullSearch"
                id="search-button"
                class="mb-4 md:mb-0 bg-success vs-con-loading__container"
                @click="showPersonList()"
              >Yeni Personel Yetkilendir</vs-button>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full mt-5">
              <vs-chip
                :key="user.User.Id"
                v-for="user in user_data.InvoiceRoleGroupRelations"
                closable
                @click="removeUser(user)"
              >
                <vs-avatar
                  :src="user.User.ProfilePicture"
                  size="30px"
                  class="border-2 border-white border-solid"
                ></vs-avatar>
                {{ user.User.FullName}}
              </vs-chip>
            </div>
          </div>
          <div class="flex flex-wrap items-center">
            <vs-button
              class="vs-con-loading__container mt-5"
              @click="submitData()"
              id="sidebarSubmit"
            >Kaydet</vs-button>
          </div>
        </ValidationObserver>
      </vx-card>
    </div>
  </div>
</template>

<script>
import UserApi from "@/api/user";
import StaffApi from "@/api/staff";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import VxAutoSuggest from "@/components/vx-auto-suggest/VxAutoSuggest.vue";

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    VxAutoSuggest
  },
  data() {
    return {
      user_data: {
        InvoiceRoleGroupRelations: []
      },
      formData: {
        InvoiceRoleGroupID: 0,
        RoleGroupName: "",
        Users: []
      },
      lastAccountsData: {},
      user_not_found: false,
      accounts: [],
      chips: [],
      submitBusy: false,
      navbarSearchAndPinList: {
        users: {
          key: "Name",
          data: []
        }
      },
      showFullSearch: false
    };
  },
  computed: {},
  methods: {
    removeUser(user) {
      if (this.showFullSearch) return;
      this.user_data.InvoiceRoleGroupRelations.splice(
        this.user_data.InvoiceRoleGroupRelations.indexOf(user),
        1
      );

      this.formData.Users.splice(this.formData.Users.indexOf(user.User.Id), 1);
    },
    showPersonList() {
      if (this.navbarSearchAndPinList.users.data.length > 0)
        this.showFullSearch = true;
    },
    hnd_search_query_update(query) {
      this.$store.commit("TOGGLE_CONTENT_OVERLAY", query ? true : false);
    },
    selected(item) {
      var id = item.users.Id;
      this.showFullSearch = false;
      if (id > 0) {
        var exists = this.formData.Users.find(x => x == id);
        if (!exists) {
          this.formData.Users.push(id);
          this.user_data.InvoiceRoleGroupRelations.push({
            User: {
              FullName: item.users.Name,
              ProfilePicture: item.users.Picture
            }
          });
        }
      }
    },

    async submitData() {
      if (this.submitBusy) return;

      const formValid = await this.$refs.editForm.validate();
      if (!formValid) return;

      this.$vs.loading({
        color: "#000",
        container: "#sidebarSubmit",
        scale: 0.45
      });

      this.submitBusy = true;

      let response = await UserApi.createRoleGroup(this.formData, this);

      if (response.data && !response.data.error && !response.data.errors) {
        this.$router.push({ name: "accessiblegroups" });
      }

      this.submitBusy = false;

      setTimeout(() => {
        this.$vs.loading.close("#sidebarSubmit .con-vs-loading");
      }, 100);
    },

    async fetchLoadData() {
      this.$vs.loading({
        color: "#000",
        container: "#page-user-view",
        scale: 0.45
      });

      let userResult = await UserApi.searchPerson(this);
      if (!userResult.data.error) {
        this.navbarSearchAndPinList.users.data = userResult.data;
      }

      setTimeout(() => {
        this.$vs.loading.close("#page-user-view .con-vs-loading");
      }, 100);
    }
  },
  created() {},
  mounted() {
    this.fetchLoadData();
  }
};
</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

td label {
  cursor: pointer;
}

#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: 0.8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width: 370px) {
          display: block;
        }
      }
    }
  }
}

@media screen and (min-width: 1201px) and (max-width: 1211px),
  only screen and (min-width: 636px) and (max-width: 991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }
}
</style>
